import React, { useState } from "react";
import { Helmet } from "react-helmet";
import FsLightbox from "fslightbox-react";
import "../../../App.css"
import image1 from "../../../Img/Proyectos/ProyectosDesarrollo/CampamentoTortuguero/Sección 01.png"
import image2 from "../../../Img/Proyectos/ProyectosDesarrollo/CampamentoTortuguero/Sección 02.png"
import image3 from "../../../Img/Proyectos/ProyectosDesarrollo/CampamentoTortuguero/Sección 03.png"
import image4 from "../../../Img/Proyectos/ProyectosDesarrollo/CampamentoTortuguero/Planta de Conjunto.jpg"
import image5 from "../../../Img/Proyectos/ProyectosDesarrollo/CampamentoTortuguero/Vista 03.jpg"
import image6 from "../../../Img/Proyectos/ProyectosDesarrollo/CampamentoTortuguero/Vista 04.jpg"
import image7 from "../../../Img/Proyectos/ProyectosDesarrollo/CampamentoTortuguero/Vista 05.jpg"

function ProyectoCampamentoTortuguero() {

    const [toggler, setToggler] = useState(false);

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    function openLightboxOnSlide(number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number
        });
    }


    return (
        <>

            <Helmet>
                <title>Varios - Campamento Tortuguero</title>
            </Helmet>

            <FsLightbox
                toggler={lightboxController.toggler}

                sources={[
                    image1, image2, image3, image4, image5, image6, image7
                ]}

                slide={lightboxController.slide}
            />

            <div className="container col-12 py-5">
                <div className="d-flex">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/proyectos-en-desarrollo">Varios</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Campamento Tortuguero</li>
                        </ol>
                    </nav>
                </div>
                <h1 className="py-2 m-0 p-0">Campamento Tortuguero</h1>
                <h6 className="py-2 m-0 p-0">Playa Chalacatepec, Jal.<h6>2019</h6></h6>
            </div>

            <div className="container position-relative">
                <img onClick={() => openLightboxOnSlide(1)} type="button" src={image1} className="w-100" alt="..." height={650} />
            </div>


            <div className="container">
                <div className="row gy-4 mt-1">

                    <div className="col-lg-6 col-md-12">
                        <img onClick={() => openLightboxOnSlide(2)}
                            src={image2}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <img onClick={() => openLightboxOnSlide(3)}
                            src={image3}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <img onClick={() => openLightboxOnSlide(4)}
                            src={image4}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <img onClick={() => openLightboxOnSlide(5)}
                            src={image5}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <img onClick={() => openLightboxOnSlide(6)}
                            src={image6}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <img onClick={() => openLightboxOnSlide(7)}
                            src={image7}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                </div>
            </div>
        </>
    );
}

export default ProyectoCampamentoTortuguero;
